export interface IPlanPeriod {
  id?: string;
  name?: string;
  startDate?: Date;
  endDate?: Date;
  note?: string | null;
  isDeleted?: boolean;
  status?: boolean;
}

export const defaultValue: Readonly<IPlanPeriod> = {
  isDeleted: false,
  status: true,
};
